export default {
    'en-US': {
      'en-US': 'English',
      'de-DE': 'German',
      'es-ES': 'Spanish',
      'it-IT': 'Italian',
      'hr-HR': 'Croatian',
      'fr-FR': 'French',
    },
    'de-DE': {
        'en-US': 'Englisch',
        'de-DE': 'Deutsch',
        'es-ES': 'Spanisch',
        'it-IT': 'Italienisch',
        'hr-HR': 'Kroatisch',
        'fr-FR': 'Französisch',
        'Web Portal Login': 'Web Portal Einloggen',
        'Login': 'Einloggen',
        'Register': 'Registrieren',
        'Change Password': 'Kennwort ändern',
        'To obtain login credentials, please contact us at': 'Um die Zugangsdaten zu erhalten, kontaktieren Sie uns bitte unter ',
        'Change Language': 'Sprache ändern',
        'ALL': 'ALLE',
        'out of': ' von ',
        'Please select language from this list': 'Bitte wählen Sie eine Sprache aus dieser Liste',
        'Close': 'Schließen',
        'Ok': 'Ok',
        'Cancel': 'Abbrechen',
        'Passcode': 'Kennwort',
        'User ID' : 'Benutzeridentifikation',
        'New Password': 'Neues Kennwort',
        'Confirm Password': 'Kennwort Bestätigen',
        'New passwords are not the same!': 'Neue Passwörter sind nicht identisch!',
        'Invalid Date format or portfolio isn\'t selected!': 'Ungültiges Datumsformat oder Portfolio ist nicht ausgewählt!',
        'Welcome to your Web Portal':'Willkommen in Ihrem Webportal'
    },
    'hr-HR': {
        'en-US': 'Engleski',
        'de-DE': 'Njemački',
        'es-ES': 'Španjolski',
        'it-IT': 'Talijanski',
        'hr-HR': 'Hrvatski',
        'fr-FR': 'Francuski',
        'Web Portal Login': 'Prijava na Web Portal',
        'Login': 'Prijava',
        'Change Password': 'Promijenite lozinku',
        'Register': 'Registracija',
        'If you experience any problems logging in, please notify us at': 'Ako imate problema s prijavom, kontaktirajte nas na ',
        'To obtain login credentials, please contact us at': 'Da biste dobili podatke za prijavu, kontaktirajte nas na ',
        'Change Language': 'Promijenite jezik',
        'ALL': 'SVE',
        'out of': ' od ',
        'Please select language from this list': 'Molimo odaberite jezik iz liste',
        'Close': 'Zatvori',
        'Ok': 'Ok',
        'Cancel': 'Prekini',
        'Passcode': 'Zaporka',
        'User ID' : 'Korisničko ime',
        'New Password': 'Nova zaporka',
        'Confirm Password': 'Potvrdi zaporku',
        'New passwords are not the same!': 'Zaporke nisu iste!',
        'Invalid Date format or portfolio isn\'t selected!': 'Pogrešan format datuma ili portfelj nije odabran!',
        'Welcome to your Web Portal':'Dobrodošli na Vaš Web Portal'        
    },
    'es-ES': {
        'en-US': 'English',
        'de-DE': 'German',
        'es-ES': 'Spanish',
        'it-IT': 'Italian',
        'hr-HR': 'Croatian',
        'fr-FR': 'French',
        'Web Portal Login': 'Inicio de sesión en el portal web',
        'Login': 'Iniciar sesión',
        'Change Password': 'Cambiar contraseña',
        'Register': 'Registrarse',
        'If you experience any problems logging in, please notify us at': 'Si tiene problemas para iniciar sesión, inicie sesión ',
        'To obtain login credentials, please contact us at': 'Para obtener credenciales de inicio de sesión, contáctenos en ',
        'Change Language': 'Cambiar idioma',
        'ALL': 'TODO',
        'out of': ' de ',
        'Please select language from this list': 'Seleccione el idioma de esta lista',
        'Close': 'Cerca',
        'Ok': 'Ok',
        'Cancel': 'Cancelar',
        'Passcode': 'Contraseña',
        'New Password': 'Nueva Contraseña',
        'Confirm Password': 'Confirmar Contraseña',
        'New passwords are not the same!': 'Nuevas contraseñas no son las mismas!',
        'Invalid Date format or portfolio isn\'t selected!': 'Formato de fecha no válida o cartera no seleccionada!'                   
    },
    'it-IT': {
        'en-US': 'Inglese',
        'de-DE': 'Tedesco',
        'es-ES': 'Spagnolo',
        'it-IT': 'Italiano',
        'hr-HR': 'Croato',
        'fr-FR': 'Franceze',
        'Web Portal Login': 'Login portale Web',
        'Login': 'Login',
        'Change Password': 'Cambia password',
        'Register': 'Registrati',
        'If you experience any problems logging in, please notify us at': 'Se si verificano problemi durante l\'accesso, si prega di avvisare noi ',
        'To obtain login credentials, please contact us at': 'Per ottenere le credenziali di accesso, ti preghiamo di contattarci a ',
        'Change Language': 'Cambia lingua',
        'ALL': 'TUTTI',
        'out of': ' di ',
        'Please select language from this list': 'Si prega di selezionare la lingua da questo elenco',
        'Close': 'Vicino',
        'Ok': 'Ok',
        'Cancel': 'Annullare',
        'Passcode': 'Parola d\'Ordine',
        'New Password': 'Parola d\'Ordine nuova',
        'Confirm Password': 'Conferma Parola d\'Ordine',
        'New passwords are not the same!': 'Le nuove password non sono uguali!',
        'Invalid Date format or portfolio isn\'t selected!': 'Formato di data o portfolio non valido non è selezionato!'              
    },
    'fr-FR': {
        'en-US': 'Anglais',
        'de-DE': 'Allemand',
        'es-ES': 'Espagnole',
        'it-IT': 'Italien',
        'hr-HR': 'Croate',
        'fr-FR': 'Français',
        'Web Portal Login': 'Connexion au portail Web',
        'Login': 'Connexion',
        'Change Password': 'Cambiar contraseña',
        'Register': 'S\'inscrire',
        'If you experience any problems logging in, please notify us at': 'Si vous rencontrez des problèmes pour vous connecter, veuillez nous en informer à ',
        'To obtain login credentials, please contact us at': 'Pour obtenir les identifiants de connexion, veuillez nous contacter à ',
        'Change Language': 'Changer de langue',
        'ALL': 'TOUT',
        'out of': ' de ',
        'Please select language from this list': 'Veuillez sélectionner une langue dans cette liste',
        'Close': 'Fermer',
        'Ok': 'Ok',
        'Cancel': 'Annuler',
        'Passcode': 'Mot de passe',
        'User ID' : 'ID de l\'utilisateur',
        'New Password': 'Nouveau mot de passe',
        'Confirm Password': 'Confirmez le mot de passe',
        'New passwords are not the same!': 'Nouveaux mots de passe sont pas identique!',
        'Invalid Date format or portfolio isn\'t selected!': "Le format de la date ou du portefeuille n'est pas valide!",
        'Welcome to your Web Portal':'Bienvenue sur votre portail Web'          
    }         
};


// WEBPACK FOOTER //
// ./app/insa-services/loginTranslations.ts